export type IonModeType = 'default' | 'ios' | 'md';
